import * as actions from 'app/actions/settings';
import http from 'app/services/http';

export const settingsReducer = (
    state = {
        keys: {},
    },
    action
) => {
    switch (action.type) {
        case 'SETTINGS_SET_KEYS': {
            const { keys } = action.payload;

            return {
                ...state,
                keys: keys,
            };
        }
        default:
            return state;
    }
};

export function settingsLoad() {
    return async function settingsLoadThunk(dispatch) {
        const { data } = await http.get('/settings');
        return dispatch(actions.setKeys(data));
    };
}

export function settingsUpdate(params) {
    return async function settingsUpdateThunk(dispatch) {
        const { data } = await http.put('/settings', params);
        return dispatch(actions.setKeys(data));
    };
}

export default settingsReducer;
